export default "__VITE_ASSET__f276193e__"